import * as React from 'react';
import { ColorTheme, COLOR_THEMES, getUniqueThemes } from 'data/ColorTheme';
import { getStoreState } from 'state/Store';
import { isPro } from 'utils';
import styled from 'styled-components';

const UpgradeBox = styled.div`
  font-weight: 400;
  font-size: 12px;
  text-align: center;
  color: var(--secondary-text-color);
  padding: 8px;
`;

interface ThemeProp {
  value: ColorTheme;
  selected: boolean;
  onSelect: (value: ColorTheme) => void;
}

const ThemeThumb: React.FunctionComponent<ThemeProp> = props => {
  const { value, selected, onSelect } = props;
  return (
    <div
      className={
        'themes-grid-item' + (selected ? ' themes-grid-item--selected' : '')
      }
      style={{ backgroundColor: value.background, color: value.foreground }}
      onClick={selected ? undefined : () => onSelect(value)}
    >
      Aa
    </div>
  );
};

interface Props {
  selectedTheme: ColorTheme | null;
  onChange: (theme: ColorTheme | null) => void;
  onUpgrade: () => void;
}

const COLUMNS_NUM = 5;

export const ThemePicker = React.forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const { selectedTheme, onUpgrade } = props;
    const user = getStoreState().app.user;
    const pro = isPro(user);
    const userThemes = pro ? user?.colorThemes ?? [] : [];
    const themes =
      userThemes.length > 0
        ? getUniqueThemes(userThemes.concat(COLOR_THEMES))
        : COLOR_THEMES;

    const emptyCells: React.ReactElement[] = [];
    while ((themes.length + emptyCells.length) % COLUMNS_NUM !== 0) {
      emptyCells.push(
        <div
          key={themes.length + emptyCells.length}
          className="themes-grid-item themes-grid-item--empty"
        />
      );
    }

    return (
      <div className="theme-picker" ref={ref}>
        <div className="themes-grid">
          {themes.map((t, index) => {
            return (
              <ThemeThumb
                value={t}
                key={index}
                selected={selectedTheme === t}
                onSelect={theme => props.onChange(theme)}
              />
            );
          })}
          {emptyCells.length > 0 && <>{emptyCells}</>}
        </div>
        {selectedTheme !== null && (
          <button
            className="template-ui-options-button"
            onClick={() => props.onChange(null)}
          >
            Use custom colors
          </button>
        )}
        {!pro && (
          <UpgradeBox>
            <a onClick={onUpgrade}>Upgrade</a> to save and use your own themes.
          </UpgradeBox>
        )}
      </div>
    );
  }
);



// WEBPACK FOOTER //
// ./src/controller/components/ThemePicker.tsx